import React, { useState, useEffect } from 'react';
import { adminApi } from '../../../services/api';
import { TrendingUp, ArrowUpRight, Clock, Target } from 'lucide-react';
import { ACCENT, GREEN, AMBER, BLUE, Spinner, KpiCard } from './shared';

export function ReferralTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    adminApi.get('/admin/analytics/detailed').then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  if (loading) return <Spinner />;
  const ref = data?.referral_stats || {};
  return (
    <div className="space-y-5" data-testid="referral-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard label="Totale referral" value={ref.total} icon={TrendingUp} color={ACCENT} testid="ref-total" />
        <KpiCard label="Completati" value={ref.completed} icon={ArrowUpRight} color={GREEN} testid="ref-completed" />
        <KpiCard label="In attesa" value={ref.pending} icon={Clock} color={AMBER} testid="ref-pending" />
        <KpiCard label="Conversione" value={`${ref.rate}%`} icon={Target} color={BLUE} testid="ref-rate" />
      </div>
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm">
        <h3 className="font-semibold text-[#1A1A1A] mb-4">Funnel referral</h3>
        <div className="space-y-4">
          {[
            { label: 'Avviati', value: ref.total, max: ref.total, color: ACCENT },
            { label: 'Completati', value: ref.completed, max: ref.total, color: GREEN },
            { label: 'In attesa', value: ref.pending, max: ref.total, color: AMBER },
          ].map(item => (
            <div key={item.label}>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-[#64748B]">{item.label}</span>
                <span className="font-bold" style={{ color: item.color }}>{item.value}</span>
              </div>
              <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
                <div className="h-full rounded-full transition-all" style={{ width: `${item.max > 0 ? (item.value / item.max) * 100 : 0}%`, background: item.color }} />
              </div>
            </div>
          ))}
        </div>
      </div>
      {(ref.top_referrers || []).length > 0 && (
        <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm">
          <h3 className="font-semibold text-[#1A1A1A] mb-4">Top ambassador</h3>
          <div className="space-y-3">
            {ref.top_referrers.map((r, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white"
                  style={{ background: i === 0 ? '#FFD700' : i === 1 ? '#C0C0C0' : i === 2 ? '#CD7F32' : '#888' }}>{i + 1}</div>
                <div className="flex-1 min-w-0">
                  <p className="text-[#1A1A1A] text-sm font-medium truncate">{r.name}</p>
                  <p className="text-[#64748B] text-xs">{r.phone}</p>
                </div>
                <span className="text-[#D44E20] font-bold text-sm tabular-nums">{r.count} referral</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
